import { render } from "./FashionTile.vue?vue&type=template&id=a0a0ff3a&ts=true"
import script from "./FashionTile.vue?vue&type=script&lang=ts"
export * from "./FashionTile.vue?vue&type=script&lang=ts"

import "./FashionTile.vue?vue&type=style&index=0&id=a0a0ff3a&lang=scss"
import "./FashionTile.vue?vue&type=style&index=1&id=a0a0ff3a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__